import { AxiosRequestHeaders } from 'axios';
import { KeyValueMap, EntryProps } from '../../commonTypes';
import { RestEndpoint } from './types';
import { AxiosInstance } from '../../commonTypes';
import * as raw from './raw';

const BASE_URL = '/products';

export const index: RestEndpoint<'Search', 'index'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  headers?: AxiosRequestHeaders
) => {
  return raw.post<EntryProps<T> | null>(http, `${BASE_URL}`, null, {
    headers: { ...headers },
  });
};
